import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const BoxContainer = styled.div`
	display: flex;
	align-items: flex-end;
	width: 100%;
	gap: 40px;
`;

export const MessageBox = styled.div<{ gray: boolean }>`
	display: flex;
	flex: 1;
	justify-content: space-between;
	background-color: ${({ gray }) =>
		gray ? tokens.color_gray_light : tokens.color_white};
	padding: ${({ gray }) =>
		gray ? '20px 30px 20px 20px' : '20px 30px 20px 0px'};
	box-shadow: ${({ gray }) =>
		gray && `0px 5px 10px 0px ${tokens.color_gray_medium}`};

	& div {
		max-width: 55vw;

		@media (max-width: 1650px) {
			max-width: 50vw;
		}

		@media (max-width: 1500px) {
			max-width: 40vw;
		}
	}

	& svg {
		cursor: pointer;
		align-self: flex-end;
	}
`;

export const EmployeeBox = styled.div`
	display: flex;
	background-color: ${tokens.color_gray_light};
	padding: 20px 30px 20px 30px;
	box-shadow: 0px 5px 10px 0px ${tokens.color_gray_medium};
	gap: 40px;
	height: 95px;

	a {
		align-self: flex-end;
	}
`;
